import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { OccurrenceContentPopup } from 'src/components';


const useStyles = makeStyles(() => ({
  root: {
    margin: '0px -24px -10px -20px',
    width: '300px',
  },
}));

const OccurrencePopup = ({ data, token }) => {
  const classes = useStyles();
  if (!data || !data[0] || !data[0].occurrences[0]) {
    return <></>;
  }
  const occurrences = data[0].occurrences;

  const images = [];
  occurrences.forEach(occurrence => {
    const occurrenceData = {
      label: occurrence.species,
      parameter: occurrence.parameter,
      value: occurrence.value,
      unit: occurrence.unit,
      date: `${occurrence.day}/${occurrence.month}/${occurrence.year}`,
      time: occurrence.time,
      sampledBy: occurrence.sampledBy,
    };
    if (occurrence.images?.length > 0) {
      occurrence.images.forEach(url => {
        images.push({ url, ...occurrenceData });
      });
    } else {
      images.push({ url: null, ...occurrenceData });
    }
  });

  return (
    <Card elevation={0} className={classes.root}>
      <OccurrenceContentPopup images={images} token={token}/>
    </Card>
  );
};

OccurrencePopup.propTypes = {
  data: PropTypes.array,
  token: PropTypes.string.isRequired,
};


export {
  OccurrencePopup,
};